import { Fight } from '../../models/fight.model';
import { RecentFightResult } from '../../models/recentFightResult.model';
import {
  createEmptyResults,
  determineFightResult,
  isCompletedFight,
  sortFightsByDate,
} from '../../utils/fight.utils';

export const retrieveMostRecentFightResults = (
  fights: Fight[],
  fighterId: string,
  numberOfFights: number = 3,
): RecentFightResult[] => {
  // Filter completed fights
  const completedFighterFights = fights.filter((fight) =>
    isCompletedFight(fight, fighterId),
  );

  // Sort and get most recent fights
  const sortedFights = sortFightsByDate(completedFighterFights);
  const results = createEmptyResults(numberOfFights);

  // Fill in fight results from oldest to most recent
  sortedFights.slice(0, numberOfFights).forEach((fight, index) => {
    results[numberOfFights - 1 - index] = {
      result: determineFightResult(fight, fighterId),
      isTitleFight: fight.title_fight === 'T',
    };
  });

  return results;
};
